<template>
  <div>
    <div style="height: 120px;"></div>
    <div class="product">
      <div class="container" style="max-width: 1160px" v-if="goodsList.length > 0">
        <div class="s" v-for="(item, index) in goodsList" :key="index" @click="handleDetails(item.id)">
          <div class="content-section">
            <div class="section-title">
              {{ item.title }}
            </div>
            <div class="section-content">
              <div class="one-fourth" v-for="(img, index1) in item.imgList" :key="index1">
                <img :src="img" width="240px" height="400px" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else style="min-height: 431px;font-size: 38px;color: #000;">
        <div style="margin-top: 50px;">暂无产品</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAppInfoList } from "@/api/api";

export default {
  name: "ProductView",
  components: {},
  data() {
    return {
      tabList: [],
      list: [],
      tabIndex: 0,
      goodsList: []
    };
  },
  mounted() {
    this.getGoodsList();
  },
  methods: {
    getGoodsList() {
      getAppInfoList().then(resp => {
        if (resp) {
          this.goodsList = resp.data.data;
        }
      });
    },
    handleDetails(id) {
      this.$router.push({ path: `/productDetails?id=` + id });
    }
  }
};
</script>

<style scoped>
.product {
  display: flex;
  width: 100%;
  justify-content: center;
  padding-bottom: 60px;
}

.content-section {
  padding-bottom: 20px;
  height: auto;
  overflow: hidden;
}

.section-title {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 35px;
  font-weight: 1000;
  color: #008cff;
  letter-spacing: 3px;
  margin-bottom: 8px;
}

.section-content {
  display: flex;
  justify-content: center;
  padding-bottom: 35px;
}

.one-fourth {
  text-align: center;
  margin-left: 45px;
}
</style>
